import React, { useState, useEffect } from 'react';
import b2bService from '../../../Services/b2bServises';
const AlternatePopup = ({
    visible,
    onHide,
    orderItem,
    alternateList = [],
    onAddAlternate
}) => {
    const [activeTab, setActiveTab] = useState(0);
    const [selectedAlternate, setSelectedAlternate] = useState(null);
    const [filteredAlternates, setFilteredAlternates] = useState(alternateList);
    const cols = [
        { field: 'medicineName', header: 'Medicine Name' },
        { field: 'manufacturer', header: 'Manufacturer' },
        { field: 'price', header: 'Price' },
        { field: 'comparisonPercentage', header: 'Comparison' }
    ];
        const cols2 = [
        { field: 'medicineName', header: 'Medicine Name' },
        { field: 'manufacturer', header: 'Manufacturer' },
 
    ];
    const recomendedMedicine = async () => {
        try {
            let user = JSON.parse(localStorage.getItem('loginObj'))
            let payload = {
                medicineId: orderItem,
                loc: user.state
            }
            const response = await b2bService.recomendedMedicine(payload);
            setFilteredAlternates(response || [])
        } catch (err) {
            console.error("Error fetching enquiry details", err);
        }
    };
    useEffect(() => {
        if (activeTab == 0) {
            recomendedMedicine()
        }
        else {
        }

    }, [activeTab])

    const searchMedicine = async (value) => {
        try {
            const payload = {
                freeTextSearch: value,
                pageNo: 1,
                pageSize: 20
            };
            const response = await b2bService.searchMedicine(payload);
            setFilteredAlternates(response)

        } catch (err) {
            console.error("Error fetching enquiry details", err);
        }
    }; const handleFilter = (e) => {
        const value = e.target.value.toLowerCase();
        searchMedicine(value)

    };

    if (!visible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-2 sm:p-0">
            <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full sm:w-[70vw] max-h-[90dvh] sm:max-h-[80vh] flex flex-col">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">
                        Add CureBay Preferred Medicine for -
                        <span className="text-blue-500 ml-1">{orderItem?.drugName}</span>
                    </h2>
                    <button
                        onClick={onHide}
                        className="text-gray-600 hover:text-black"
                    >
                        ✕
                    </button>
                </div>

                <div className="border-b border-gray-200 mb-4">
                    <div className="flex space-x-4">
                        <button
                            className={`py-2 px-4 ${activeTab === 0 ? 'border-b-2 border-blue-500 font-medium' : 'text-gray-500'}`}
                            onClick={() => setActiveTab(0)}
                        >
                            Recommended
                        </button>
                        <button
                            className={`py-2 px-4 ${activeTab === 1 ? 'border-b-2 border-blue-500 font-medium' : 'text-gray-500'}`}
                            onClick={() => setActiveTab(1)}
                        >
                            Manual
                        </button>
                    </div>
                </div>

                <div className="flex-1 min-h-0 overflow-auto">
                    {activeTab === 0 ? (
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        {cols.map(col => (
                                            <th
                                                key={col.field}
                                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-r border-gray-200"
                                            >
                                                {col.header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredAlternates?.length > 0 ? (
                                        filteredAlternates.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={`cursor-pointer ${selectedAlternate?.id === item.id ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
                                                onClick={() => setSelectedAlternate(item)}
                                            >
                                                {cols.map(col => (
                                                    <td
                                                        key={`${index}-${col.field}`}
                                                        className="px-6 py-4 whitespace-nowrap border-r border-gray-200"
                                                    >
                                                        {col.field === 'comparisonPercentage' ? (
                                                            <span className="text-blue-500 font-bold">
                                                                {item[col.field]}%
                                                            </span>
                                                        ) : (
                                                            item[col.field]
                                                        )}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={cols.length} className="px-6 py-4 text-center">
                                                <strong>There is no CureBay Preferred Medicine available for this.</strong>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <>
                            <div className="w-full sm:w-1/2">
                                <input
                                    type="text"
                                    placeholder="Search medicine..."
                                    className="w-full p-2 border rounded mb-4"
                                    onChange={handleFilter}
                                />

                            </div>
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            {cols2.map(col => (
                                                <th
                                                    key={col.field}
                                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-r border-gray-200"
                                                >
                                                    {col.header}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {filteredAlternates?.length > 0 ? (
                                            filteredAlternates?.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    className={`cursor-pointer ${selectedAlternate?.id === item.id ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
                                                    onClick={() => setSelectedAlternate(item)}
                                                >
                                                    {cols2.map(col => (
                                                        <td
                                                            key={`${index}-${col.field}`}
                                                            className="px-6 py-4 whitespace-nowrap border-r border-gray-200"
                                                        >
                                                            {col.field === 'comparisonPercentage' ? (
                                                                <span className="text-blue-500 font-bold">
                                                                    {item[col.field]}%
                                                                </span>
                                                            ) : (
                                                                item[col.field]
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={cols2.length} className="px-6 py-4 text-center">
                                                    <strong>There is no Preferred Medicine available for this.</strong>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>

                <div className="mt-4 text-right">
                    <button
                        onClick={() => {
                            onAddAlternate(selectedAlternate,filteredAlternates);
                            onHide();
                        }}
                        className="bg-[#336b3b] text-white px-4 py-2 rounded"
                        disabled={!selectedAlternate}
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AlternatePopup;